import { currencyFormat } from 'utils/formatting-utils'

/**
 * Formats numbers into ticker prices
 * @param processedValue
 * @param isPositive
 * @param isSymbol
 * @returns
 */
export const formatNumberAsTicker = (
  processedValue: number,
  isPositive: boolean,
  isSymbol: boolean,
): string => {
  if (isPositive && isSymbol) {
    return `+${processedValue}`
  } else if (!isPositive && !isSymbol) {
    return `${processedValue}`.substring(1)
  } else {
    return `${processedValue}`
  }
}

/**
 * Formats numbers as currency applies ticker symbols
 * @param processedValue
 * @param isPositive
 * @param isSymbol
 * @returns
 */
export const formatNumberAsCurrency = (
  processedValue: number,
  isPositive: boolean,
  isSymbol: boolean,
): string => {
  if (isPositive && isSymbol) {
    return `+${currencyFormat(processedValue)}`
  } else {
    return `${currencyFormat(processedValue)}`
  }
}
